import { render } from "./ReviewBusinessNames.vue?vue&type=template&id=b78dfd22"
import script from "./ReviewBusinessNames.vue?vue&type=script&lang=js"
export * from "./ReviewBusinessNames.vue?vue&type=script&lang=js"

import "./ReviewBusinessNames.vue?vue&type=style&index=0&id=b78dfd22&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__